import script from "./OrderFileForm.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderFileForm.vue?vue&type=script&setup=true&lang=js"

import "./OrderFileForm.vue?vue&type=style&index=0&id=597a15a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-597a15a2"]])

export default __exports__